
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#989AB3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M17.384 10.772a2.514 2.514 0 002.162-2.484c0-1.249-.91-2.284-2.104-2.48m1.552 7.897c1.181.176 2.006.59 2.006 1.443 0 .586-.389.968-1.016 1.207"}}),_c('path',{attrs:{"stroke":"#989AB3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M12.136 14.066c-2.81 0-5.21.426-5.21 2.127 0 1.7 2.385 2.138 5.21 2.138 2.811 0 5.21-.421 5.21-2.123 0-1.702-2.384-2.142-5.21-2.142zm.001-2.427a3.34 3.34 0 10-3.34-3.34 3.327 3.327 0 003.315 3.34h.025z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#989AB3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M6.888 10.772a2.513 2.513 0 01-2.161-2.484c0-1.249.91-2.284 2.104-2.48m-1.553 7.897c-1.18.176-2.006.59-2.006 1.443 0 .586.389.968 1.017 1.207"}})])
          )
        }
      }
    